import "moment/locale/id";
import { Route, Routes } from "react-router-dom";
import Loadable from 'react-loadable';
import PageLoader from "components/PageLoader";

const LazyDiscount = Loadable({
    loader: () => import("pages/Discount/index"),
    loading: () => <PageLoader />,
});

const LazyDiscountForm = Loadable({
    loader: () => import("pages/DiscountForm/index"),
    loading: () => <PageLoader />,
});


function DiscountRoute() {
    return (
        <Routes>
            <Route path="/" element={<LazyDiscount />} />
            <Route path="/new" element={<LazyDiscountForm type="new" />} />
            <Route path="/edit/:discount_id" element={<LazyDiscountForm type="edit" />} />
        </Routes>
    );
}

export default DiscountRoute;
